import useSWR from 'swr';
import request from '@/utils/request';
export type MobileTelemetryLevel = 'off' | 'normal' | 'debug';
export type MobileTelemetrySettings = { level: MobileTelemetryLevel };
export type MobileTelemetryEvent = Record<string, unknown>;
const apiUrl = '/answer/admin/api/mobile-telemetry/settings';
export const useMobileTelemetrySettings = () => { const { data, error, mutate } = useSWR<MobileTelemetrySettings, Error>([apiUrl], request.instance.get); return { data, error, mutate, isLoading: !data && !error }; };
export const updateMobileTelemetrySettings = (level: MobileTelemetryLevel) => request.put<MobileTelemetrySettings>(apiUrl, { level });
export const useMobileTelemetryEvents = () => useSWR<{ events: MobileTelemetryEvent[] }, Error>(['/answer/admin/api/mobile-telemetry/events'], request.instance.get);
export type MobileTelemetryStats = {
  days: Array<{ date: string; first_activations: number; online_users: number; users: string[]; retention: number[] }>;
  average_retention: number[];
  week_average: number;
  business: Record<string, Record<string, number>>;
};
export const useMobileTelemetryStats = () => useSWR<MobileTelemetryStats, Error>(['/answer/admin/api/mobile-telemetry/stats'], request.instance.get);
